/** @type {import('../schema').ProcessDefinition} */
const multas = {
  id: "multas",
  name: "Multas",
  category: "finanzas",
  outcome: "Sancionar a un residente; la multa se cobra vía el cierre.",
  trigger: "El Administrador crea una multa.",
  actors: ["Administrador", "Residente", "Sistema"],
  status: "COMPLETO",
  description:
    "Alta de una multa, su inclusión en el cierre, pago cuando se salda, anulación por el admin y apelación del residente.",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
    { id: "res", actor: "Residente" },
  ],
  steps: [
    {
      id: "s1",
      laneId: "admin",
      type: "start",
      label: "Alta de la multa",
      description:
        "Unidad, residente (propietario/inquilino), monto, moneda, motivo, referencia legal y fondo destino. Nace activa.",
      evidence: "src/screens/admin/MultasAdmin.jsx:174-289",
    },
    {
      id: "s2",
      laneId: "sys",
      type: "decision",
      label: "¿La multa sigue activa al cerrar?",
      description:
        "Si sigue activa se incorpora a la deuda del próximo cierre; si fue anulada antes, no.",
    },
    {
      id: "s3",
      laneId: "sys",
      type: "task",
      label: "Inclusión en cierre",
      description:
        "Se incorpora a la deuda del próximo cierre (includedInCierreId).",
      evidence: "src/screens/admin/CobranzaAdmin.jsx",
    },
    {
      id: "s4",
      laneId: "res",
      type: "decision",
      label: "¿El residente paga o apela?",
      description:
        "El residente puede saldar la multa incluida o presentar una apelación.",
    },
    {
      id: "s5",
      laneId: "sys",
      type: "task",
      label: "Pago de la multa",
      description:
        "Cuando el pago que la incluye se salda, la multa pasa a pagada.",
    },
    {
      id: "s6",
      laneId: "admin",
      type: "decision",
      label: "¿La apelación procede?",
      description:
        "El admin acepta (anula la multa, appealStatus: accepted) o rechaza (con motivo).",
    },
    {
      id: "s7",
      laneId: "admin",
      type: "task",
      label: "Anulación de la multa",
      description:
        "El Administrador la marca anulada (con motivo). Apelación aceptada o anulación directa.",
    },
    {
      id: "s8",
      laneId: "sys",
      type: "end",
      label: "Multa pagada",
    },
    {
      id: "s9",
      laneId: "admin",
      type: "end",
      label: "Multa anulada",
    },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3", label: "Activa" },
    { from: "s2", to: "s7", label: "Anulada antes" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5", label: "Paga" },
    { from: "s4", to: "s6", label: "Apela" },
    { from: "s5", to: "s8" },
    { from: "s6", to: "s7", label: "Procede" },
    { from: "s6", to: "s4", label: "Rechazada" },
    { from: "s7", to: "s9" },
  ],
};
export default multas;
